module.exports = "/assets/bw_share.png?RitHis6";